import { Card, CardBody, Box, Heading, BoxProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';

interface ISectionProps extends BoxProps {
  children?: string | React.ReactNode;
  title?: string;
  selector?: string;
  label?: string;
  amount?: string;
  isTotal?: boolean;
  isValid?: boolean;
}

interface IMarginProps {
  hasMargin?: boolean;
}

const SectionCard = (props: ISectionProps) => {
  const { children } = props;
  return (
    <Card variant="filled" borderRadius="lg" mb={6} {...props}>
      <CardBody>{children}</CardBody>
    </Card>
  );
};

const Section = (props: ISectionProps) => {
  const { children, title } = props;
  return (
    <Box mb={8} _last={{ mb: 0 }} {...props}>
      <Heading as="h3" mb={3} fontSize="lg" textAlign="left" fontWeight="medium" letterSpacing="tight" color="muted">
        {title}
      </Heading>

      {children}
    </Box>
  );
};

const ItemAmount = (props: ISectionProps & IMarginProps) => {
  const { label, amount, hasMargin } = props;
  return (
    <Box as="dl" display="flex" py={1} ml={{ base: 0, lg: 6 }} gap={3}>
      <Box as="dt" flexGrow={1}>
        {label}
      </Box>

      <Box
        as="dd"
        textAlign="right"
        mr={hasMargin ? { base: 0, lg: '8rem' } : 0}
        letterSpacing="tighter"
        sx={{ fontVariantNumeric: 'lining-nums tabular-nums' }}
      >
        {amount}
      </Box>
    </Box>
  );
};

const ItemValidity = (props: ISectionProps) => {
  const { label, isValid } = props;
  return (
    <Box display="flex" py={1} gap={2}>
      <Box as="span" color={isValid ? 'green.400' : 'extra-muted'}>
        <FontAwesomeIcon icon={isValid ? faCheckCircle : faTimesCircle} size="lg" fixedWidth />
      </Box>

      {label}
    </Box>
  );
};

const Total = (props: ISectionProps) => {
  const { label, amount } = props;
  return (
    <Box as="dl" data-selector="funding-total" display="flex" my={2} gap={3} fontSize="lg">
      <Box as="dt" data-selector="total-label" flexGrow={1} fontWeight="medium" letterSpacing="tight" color="muted">
        {label}
      </Box>

      <Box
        as="dd"
        data-selector="total-amount"
        textAlign="right"
        fontWeight="medium"
        letterSpacing="tighter"
        sx={{ fontVariantNumeric: 'lining-nums tabular-nums' }}
      >
        {amount}
      </Box>
    </Box>
  );
};

export { SectionCard, Section, ItemAmount, ItemValidity, Total };
